var React = require('react');
var createReactClass = require('create-react-class');
var Callout = require('../../components/callout.jsx');

var PracticeConfirmationPage = createReactClass({
  handleClickTracking: function (e) {
    var label = 'Custom Clinic Account Completion Page';
    var action = 'Click';
    this.props.recordPasswordResetClick(action, label);
  },

  handleSubmit: function (event) {
    event.preventDefault();
    var accessToken = this.props.auth.token;

    this.props.resetPasswordWithAccessToken(
      this.refs.password.value,
      accessToken
    );

    this.props.revertIsPending(accessToken);
  },

  render: function () {
    var logoUrl =
      'https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/web/logo.png';

    var errorMsg =
      this.props.password &&
      Object.keys(this.props.password.error).length > 0 &&
      (this.props.password.error.message
        ? this.props.password.error.message
        : this.props.password.error.toString());

    return (
      <section className="confirmation-page">
        <div className="row">
          <div className="column small-6 small-centered">
            <img src={logoUrl} alt="MyGiHealth" />
          </div>
        </div>
        <div className="row text-center">
          <div className="column small-10 small-centered">
            <p>Congratulations, your history has been sent to your doctor!</p>
            <br />
            <p>
              You can learn more about your GI conditions and review your
              history and track your symptoms by visiting mygi.health, all you
              need to do to set up your account is create a password below and
              follow the link.
            </p>
          </div>
        </div>
        <div className="row text-center">
          <div className="column small-8 small-centered">
            {errorMsg && (
              <Callout
                type="alert"
                message={errorMsg}
                handleClose={this.props.clearError}
              />
            )}
            <div className="form">
              <form onSubmit={this.handleSubmit} noValidate>
                <div className="input-field-wrapper">
                  <div className="input-field">
                    <input
                      type="password"
                      name="password"
                      id="password"
                      ref="password"
                      placeholder="Enter password"
                      required
                    />
                  </div>
                </div>
                <button
                  className="button success float-center"
                  type="submit"
                  onClick={this.handleClickTracking}
                >
                  Take me to mygi.health
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    );
  },
});

module.exports = PracticeConfirmationPage;



// WEBPACK FOOTER //
// ./src/common/routes/practice/components/practiceConfirmationPage.jsx